import React, { Component } from 'react';
import LoadingAnimation from '@/shared/components/LoadingAnimation';

class AudioViewer extends Component {
  state = {
    loading: true,
  };

  onCanPlay() {
    this.setState({ loading: false });
  }

  renderLoading() {
    if (this.state.loading) {
      return <LoadingAnimation />;
    }
    return null;
  }

  render() {
    const { loading } = this.state;
    const { mimeType, filePath, fileName } = this.props;
    const visibility = loading ? 'hidden' : 'visible';
    return (
      <div className="pg-driver-view">
        <div className="video-container">
          {this.renderLoading()}
          <audio
            style={{ visibility }}
            controls
            onCanPlay={e => this.onCanPlay(e)}
            src={filePath}
            type={mimeType}
          >
            <track label={fileName} kind="captions" default />
            <p>Video playback is not supported by your browser.</p>
          </audio>
        </div>
      </div>
    );
  }
}

export default AudioViewer;
